import { utils, i18n, CurrentUser, http } from '@common';
import { accountService } from '@api';

export const getSingPass = async () => {
    const transferData = JSON.parse(sessionStorage['transferData'] || null);
    const params = utils.geturlparam(window?.location.search);
    const { detail = '' } = transferData;
    const { SingPass = '' } = detail;
    const { obj } = params;
    const authParamsSupplier = async () => {
        return {
            state: obj?.proxyState,
            nonce: "dummySessionNonce"
        };
    };

    const onError = (errorId, message) => {
        console.log(`onError. errorId:${errorId} message:${message}`);
    };

    const initAuthSessionResponse = window.NDI.initAuthSession(
        'ndi-qr', {
        clientId: SingPass?.clientId,
        redirectUri: SingPass?.redirect_Uri,
        scope: SingPass?.scope,
        responseType: SingPass?.response_Type
    },
        authParamsSupplier,
        onError, {
        renderRedirectLink: true,
        // renderDownloadLink: true,
        // appLaunchUrl: 'https://partner.gov.sg'   
    },
    );
    console.log('initAuthSession: ', initAuthSessionResponse);

    const singpassPasswordLogin = document.getElementById('ndi-redirect-link');  //this code can only put the line which after AuthSession init.

    if (singpassPasswordLogin) {
        singpassPasswordLogin.onclick = function () {
            utils.redirectTo(`/realm/processlogin?logicalName=${SingPass?.logicalName || null}`, true);
        };
    }
};

export const redirectTransferTo = (logicalName, from = '', userName = '', proxyState = '') => {
    if (userName && logicalName) {
        utils.redirectTo(`/realm/processlogin?logicalName=${logicalName}&username=${userName}&from=${from}`, true);
    } else if (logicalName && proxyState) {
        utils.redirectTo(`/realm/processlogin?logicalName=${logicalName || null}&from=${from}&proxyState=${proxyState}`, true);
    } else if (logicalName) {
        utils.redirectTo(`/realm/processlogin?logicalName=${logicalName || null}&from=${from}`, true);
    }
    return;
};

export const transferToRetrieve = (logicalName, from = '', proxyState = '') => {
    utils.redirectTo(`/realm/processRetrieve?logicalName=${logicalName}&from=${from}${proxyState ? '&proxyState=' + proxyState : ''}`, true);
};

export const backToLogin = (proxyState = '') => {
    window.location.href = `/realm/redoLogin?proxyState=${proxyState}`;
};

export const copyInputKey = (value) => {
    let transfer = document.createElement('input');
    document.body.appendChild(transfer);
    transfer.value = value;
    transfer.setAttribute('readonly', 'readonly');
    transfer.setAttribute('value', value);
    transfer.focus();
    transfer.select();
    transfer.setSelectionRange(0, value?.length);
    transfer.blur();
    try {
        document.execCommand('copy');
        document.body.removeChild(transfer);
        $$.toast(i18n.get('CIS_Retrieve_CopySuccess_Message'), 'success');
    } catch (err) {
        $$.toast(i18n.get('CIS_Retrieve_CopyFailed_Message'), 'error');
        document.body.removeChild(transfer);
    }
};

export const setCookie = (cname, cvalue, exmins) => {
    let d = new Date();
    d.setTime(d.getTime() + (exmins * 60 * 1000));
    const expires = "expires=" + d.toGMTString();
    document.cookie = cname + "=" + cvalue + "; " + expires;
};

export const getCookie = (cname) => {
    let name = cname + "=";
    let ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i].trim();
        if (c.indexOf(name) == 0) return c.substring(name.length, c.length);
    }
    return undefined;
};